export { default as Tariff } from './Tariff';
export { default as TariffsContainer } from './TariffsContainer';



// WEBPACK FOOTER //
// ./src/components/tariff/index.jsx